import moment from "moment-timezone";

export default ({dateString = '', timezone = 'America/Toronto', parseFormat, displayFormat, name}) => {

    const tzDate = moment.parseZone(dateString, parseFormat);
    const tzAdjusted = tzDate.tz(timezone);

    if (!tzAdjusted || !tzAdjusted.isValid()) {
        return null;
    }

    const tzAdjustedHour = tzAdjusted.hour();
    const date = moment(dateString, parseFormat);

    let output = tzAdjusted;
    if (name && name === 'checkin' && !(tzAdjustedHour > 12 && tzAdjustedHour <= 17)) {
        output = date;
    }
    if (name && name === 'checkout' && !(tzAdjustedHour >= 8 && tzAdjustedHour < 12)) {
        output = date;
    }

    return (displayFormat) ? output.format(displayFormat) : output
}